export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/zh-hk.lyaml"));
at({ "zh-hk": { "public": { "sampleString": "\u7BC4\u4F8B\u5B57\u4E32" } } });
};